import { render, staticRenderFns } from "./SoQuitButton.container.vue?vue&type=template&id=4d4caa02&"
import script from "./SoQuitButton.container.vue?vue&type=script&lang=js&"
export * from "./SoQuitButton.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports